@if (rootModel()) {
<div class="type-tree">
    <span #menuTrigger style="position: fixed" [matMenuTriggerFor]="menu" [style.left]="menuPosition.x + 'px'"
        [style.top]="menuPosition.y + 'px'"></span>
    <app-type-node [model]='rootModel()'></app-type-node>
    <mat-menu #menu="matMenu">
        <ng-template matMenuContent let-component="component" let-menu="menu">
            <button mat-menu-item [disabled]="!menu.category" (click)="onCategory()">
                <mat-icon>create_new_folder</mat-icon>
                <span>New Category</span>
            </button>
            <button mat-menu-item [disabled]="!menu.type" (click)="onType()">
                <mat-icon>playlist_add</mat-icon>
                <span>Add Type</span>
            </button>
            <button mat-menu-item [disabled]="!menu.delete" (click)="onDelete(current)">
                <mat-icon>close</mat-icon>
                <span>Delete</span>
            </button>
            <button mat-menu-item [disabled]="!menu.cut" (click)="onCut(current)">
                <mat-icon>flip_to_front</mat-icon>
                <span>Cut</span>
            </button>
            <button mat-menu-item [disabled]="!menu.copy" (click)="onCopy(current)">
                <mat-icon>flip_to_back</mat-icon>
                <span>Copy</span>
            </button>
            <button mat-menu-item [disabled]="!menu.paste" (click)="onPaste()">
                <mat-icon>library_add</mat-icon>
                <span>Paste</span>
            </button>
        </ng-template>
    </mat-menu>
</div>
}
